module.exports = {
	'edit': '编辑',
	'reply': '回复 ',
	'cancel': '取消',
	'submit': '提交',
	'tip.content': '内容不能超过 {{max}} 个字符',
	'content.input': '请输入内容',
	'rate.input': '请选择评分',
	'content': '内容',
	'rate': '评分',
	'load.more': '加载更多',
	'no.data': '暂无数据',
	'use': '有用',
	'useless': '没用',
	'my.comment': '我的评价',
	'summary': '共',
	'comments': '个评价',
	'great': '非常好',
	'good': '好',
	'bad': '差',
	'sucks': '很差',
	'ok': '一般',
	'owner': '组件作者',
	'item': '个'
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.zh-cn.js